import { Images, QuestionGroup, QuestionType, ScenarioStep, Steps } from '../state/interfaces'
import {
  confirm,
  thanks,
  addressLocation,
  selectCurrentProvider,
  emailAddress,
  provinces,
  postalCodeInternet,
  internetSpeed,
} from './common-steps'
import { currentProviderInternet, internetSpeedG, sliderData } from './internet-steps'
import { callingOptions, currentProviderMobile, howMuchDataC, sliderData as sliderDataMobile } from './mobile-steps'

export const startMobileAlert: ScenarioStep = {
  id: Steps.START_MOBILE_ALERT,
  group: QuestionGroup.ALERT,
  question: 'start-alert_question',
  tip: 'start-alert_tip',
  type: QuestionType.ALERT_CRITERIA,
  next: Steps.PROVINCE,
  answers: [
    {
      id: 'start',
      text: 'common_start',
    },
  ],
  metadata: { grandImage: Images.ALERT_1 },
}

export const startInternetAlert: ScenarioStep = {
  id: Steps.START_INTERNET_ALERT,
  group: QuestionGroup.ALERT,
  question: 'start-alert_question',
  tip: 'start-alert_tip',
  type: QuestionType.ALERT_CRITERIA,
  next: Steps.INTERNET_SPEED,
  answers: [
    {
      id: 'start',
      text: 'common_start',
    },
  ],
}

export const startFiberOpticAlert: ScenarioStep = {
  id: Steps.START_FIBER_OPTIC_ALERT,
  group: QuestionGroup.ALERT,
  question: 'start-alert_question',
  type: QuestionType.ALERT_CRITERIA,
  next: Steps.ADDRESS_LOCATION,
  answers: [
    {
      id: 'start',
      text: 'common_start',
    },
  ],
}

export const provincesStepMobileAlert = {
  ...provinces,
  next: Steps.HOW_MANY_CALLING_MINUTES,
}

export const provincesStepInternetAlert = {
  ...provinces,
  next: Steps.EMAIL_ADDRESS,
}

export const provincesStepMobileObserverAlert = {
  ...provinces,
  next: Steps.CURRENT_PROVIDER,
}

export const optionsAlert: ScenarioStep = {
  id: Steps.OPTIONS_ALERT,
  group: QuestionGroup.ALERT,
  question: 'options-alert_question',
  tip: 'options-alert_tip',
  type: QuestionType.CHOICE_AS_MULTISELECT_PILLS,
  next: Steps.CURRENT_PROVIDER,
  answers: [
    { id: 'cable', text: 'common_cable' },
    { id: 'dsl-fttn', text: 'common_dsl-fttn' },
    { id: 'ftth', text: 'common_ftth' },
    { id: 'wireless', text: 'common_wireless' },
    { id: 'satellite', text: 'common_satellite' },
    { id: 'modem', text: 'common_modem-included' },
  ],
}

export const currentMonthlyPayment: ScenarioStep = {
  id: Steps.CURRENT_MONTHLY_PAYMENT,
  group: QuestionGroup.ALERT,
  question: 'current-monthly-payment_question',
  tip: 'current-monthly-payment_tip',
  type: QuestionType.INPUT_CURRENCY,
  answerPlaceholder: 'current-monthly-payment_answerPlaceholder',
  next: Steps.SAVINGS_PERCENT,
  answers: [],
}

export const currentMonthlyPaymentAlert: ScenarioStep = {
  id: Steps.HOW_MUCH_PAYMENT,
  group: QuestionGroup.ALERT,
  question: 'how-much-payment_question',
  tip: 'how-much-payment_tip',
  type: QuestionType.INPUT_CURRENCY,
  answerPlaceholder: 'how-much-payment_answerPlaceholder',
  next: Steps.EMAIL_ADDRESS,
  answers: [],
}

export const currentMonthlyPaymentObserverAlert: ScenarioStep = {
  ...currentMonthlyPaymentAlert,
  tip: 'how-much-payment-alert-observer_tip',
  next: Steps.CONFIRM_ALERT,
}

// export const sliderSavingsPercent: ScenarioStep = {
//   id: Steps.SAVINGS_PERCENT,
//   group: QuestionGroup.ALERT,
//   question: 'savings-percent_question',
//   tip: 'savings-percent_tip',
//   type: QuestionType.SLIDER,
//   next: Steps.EMAIL_ADDRESS,
//   answers: [],
// }

// export const sliderSavingsPercent: ScenarioStep = {
//   id: Steps.DESIRED_PAYMENT,
//   group: QuestionGroup.ALERT,
//   question: 'savings-percent_question',
//   tip: 'savings-percent_tip',
//   type: QuestionType.INPUT_SAVINGS,
//   answerPlaceholder: 'savings-percent_answerPlaceholder',
//   next: Steps.EMAIL_ADDRESS,
//   answers: [],
// }

export const sliderSavingsPercent: ScenarioStep = {
  id: Steps.SAVINGS_PERCENT,
  group: QuestionGroup.ALERT,
  question: 'savings-percent_question',
  tip: 'savings-percent_tip',
  type: QuestionType.CHOICE_AS_PILLS,
  answerPlaceholder: 'savings-percent_answerPlaceholder',
  answers: [
    { id: '10', text: { key: 'common_percentage', options: { percentage: 10 } }, next: Steps.EMAIL_ADDRESS },
    { id: '20', text: { key: 'common_percentage', options: { percentage: 20 } }, next: Steps.EMAIL_ADDRESS },
    { id: '30', text: { key: 'common_percentage', options: { percentage: 30 } }, next: Steps.EMAIL_ADDRESS },
  ],
}

export const internetSpeedCompetition: ScenarioStep = {
  ...internetSpeed,
  answers: [
    { id: '0', text: { key: 'common_min', options: { count: 0 } }, next: Steps.CURRENT_PROVIDER },
    { id: '10', text: { key: 'common_mbps-amount', options: { count: 10 } }, next: Steps.CURRENT_PROVIDER },
    { id: '15', text: { key: 'common_mbps-amount', options: { count: 15 } }, next: Steps.CURRENT_PROVIDER },
    { id: '25', text: { key: 'common_mbps-amount', options: { count: 25 } }, next: Steps.CURRENT_PROVIDER },
    { id: '30', text: { key: 'common_mbps-amount', options: { count: 30 } }, next: Steps.CURRENT_PROVIDER },
    { id: '40', text: { key: 'common_mbps-amount', options: { count: 40 } }, next: Steps.CURRENT_PROVIDER },
    { id: '50', text: { key: 'common_mbps-amount', options: { count: 50 } }, next: Steps.CURRENT_PROVIDER },
    { id: '60', text: { key: 'common_mbps-amount', options: { count: 60 } }, next: Steps.CURRENT_PROVIDER },
    { id: '100', text: { key: 'common_mbps-amount', options: { count: 100 } }, next: Steps.CURRENT_PROVIDER },
    { id: '120', text: { key: 'common_mbps-amount', options: { count: 120 } }, next: Steps.CURRENT_PROVIDER },
    { id: '200', text: { key: 'common_mbps-amount', options: { count: 200 } }, next: Steps.CURRENT_PROVIDER },
    { id: '250', text: { key: 'common_mbps-amount', options: { count: 250 } }, next: Steps.CURRENT_PROVIDER },
    { id: '300', text: { key: 'common_mbps-amount', options: { count: 300 } }, next: Steps.CURRENT_PROVIDER },
    { id: '400', text: { key: 'common_mbps-amount', options: { count: 400 } }, next: Steps.CURRENT_PROVIDER },
    { id: '500', text: { key: 'common_mbps-amount', options: { count: 500 } }, next: Steps.CURRENT_PROVIDER },
    { id: '900', text: { key: 'common_mbps-amount', options: { count: 900 } }, next: Steps.CURRENT_PROVIDER },
  ],
}

export const internetSpeedAlert: ScenarioStep = {
  ...internetSpeed,
  next: Steps.POSTAL_CODE_INTERNET,
  group: QuestionGroup.ALERT,
  answers: [
    { id: '0Mbps', text: { key: 'common_min', options: { count: 0 } } },
    { id: '10Mbps', text: { key: 'common_mbps-amount', options: { count: 10 } } },
    { id: '15Mbps', text: { key: 'common_mbps-amount', options: { count: 15 } } },
    { id: '25Mbps', text: { key: 'common_mbps-amount', options: { count: 25 } } },
    { id: '30Mbps', text: { key: 'common_mbps-amount', options: { count: 30 } } },
    { id: '40Mbps', text: { key: 'common_mbps-amount', options: { count: 40 } } },
    { id: '50Mbps', text: { key: 'common_mbps-amount', options: { count: 50 } } },
    { id: '60Mbps', text: { key: 'common_mbps-amount', options: { count: 60 } } },
    { id: '100Mbps', text: { key: 'common_mbps-amount', options: { count: 100 } } },
    { id: '120Mbps', text: { key: 'common_mbps-amount', options: { count: 120 } } },
    { id: '200Mbps', text: { key: 'common_mbps-amount', options: { count: 200 } } },
    { id: '250Mbps', text: { key: 'common_mbps-amount', options: { count: 250 } } },
    { id: '300Mbps', text: { key: 'common_mbps-amount', options: { count: 300 } } },
    { id: '400Mbps', text: { key: 'common_mbps-amount', options: { count: 400 } } },
    { id: '500Mbps', text: { key: 'common_mbps-amount', options: { count: 500 } } },
    { id: '900Mbps', text: { key: 'common_mbps-amount', options: { count: 900 } } },
  ],
}

export const internetSpeedAlertB: ScenarioStep = {
  ...internetSpeed,
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  tip: 'internet-speed-with-slide_tip',
  metadata: { grandImage: Images.SPEED_SEARCH },
  answers: [
    { id: '10', text: { key: 'common_mbps-amount', options: { count: 10 } }, next: Steps.POSTAL_CODE_INTERNET },
    { id: '30', text: { key: 'common_mbps-amount', options: { count: 30 } }, next: Steps.POSTAL_CODE_INTERNET },
    { id: '60', text: { key: 'common_mbps-amount', options: { count: 60 } }, next: Steps.POSTAL_CODE_INTERNET },
    { id: '100', text: { key: 'common_mbps-amount', options: { count: 100 } }, next: Steps.POSTAL_CODE_INTERNET },
    { id: '500', text: { key: 'common_mbps-amount', options: { count: 500 } }, next: Steps.POSTAL_CODE_INTERNET },
    { id: '900', text: { key: 'common_mbps-amount', options: { count: 900 } }, next: Steps.POSTAL_CODE_INTERNET },
    { id: 'custom-speed', text: 'common_custom-speed', next: Steps.SLIDER_DATA_AMOUNT },
  ],
}

export const sliderDataAlert: ScenarioStep = {
  id: Steps.SLIDER_DATA_AMOUNT,
  group: QuestionGroup.DEFAULT,
  question: 'slider-data_question',
  type: QuestionType.SLIDER_DATA,
  next: Steps.POSTAL_CODE_INTERNET,
  answers: [],
  metadata: {
    defaultValue: 20,
    min: 0,
    max: 200,
    colorScheme: 'teal',
    sliderMark: [
      {
        value: 0,
        text: '0',
      },
      {
        value: 50,
        text: '50',
      },
      {
        value: 100,
        text: '100',
      },
      {
        value: 200,
        text: '900',
      },
    ],
    dataUnitType: 'Mbps',
    step: 1,
  },
}

// export const monthlyUsage: ScenarioStep = {
//   id: Steps.MONTHLY_USAGE,
//   group: QuestionGroup.ALERT,
//   question: 'monthly-usage_question',
//   type: QuestionType.CHOICE_AS_PILLS,
//   answers: [
//     { id: '0MB', text: { key: 'common_mb-amount', options: { count: 0 } }, next: Steps.CURRENT_PROVIDER },
//     { id: '25GB', text: { key: 'common_gb-amount', options: { count: 25 } }, next: Steps.CURRENT_PROVIDER },
//     { id: '50GB', text: { key: 'common_gb-amount', options: { count: 50 } }, next: Steps.CURRENT_PROVIDER },
//     { id: '100GB', text: { key: 'common_gb-amount', options: { count: 100 } }, next: Steps.CURRENT_PROVIDER },
//     { id: '200GB', text: { key: 'common_gb-amount', options: { count: 200 } }, next: Steps.CURRENT_PROVIDER },
//     { id: '300GB', text: { key: 'common_gb-amount', options: { count: 300 } }, next: Steps.CURRENT_PROVIDER },
//     { id: '500GB', text: { key: 'common_gb-amount', options: { count: 500 } }, next: Steps.CURRENT_PROVIDER },
//     { id: 'unlimited', text: 'common_unlimited-data', next: Steps.CURRENT_PROVIDER },
//   ],
// }

export const emailAddressAlert: ScenarioStep = {
  ...emailAddress,
  group: QuestionGroup.ALERT,
  next: Steps.CONFIRM_ALERT,
  metadata: { grandImage: Images.ALERT_2 },
}

export const emailAddressObserverAlertMobile: ScenarioStep = {
  ...emailAddressAlert,
  tip: 'email-address-alert_tip',
  next: Steps.PROVINCE,
}

export const emailAddressObserverAlertInternet: ScenarioStep = {
  ...emailAddressAlert,
  tip: 'email-address-alert_tip',
  next: Steps.CURRENT_PROVIDER,
}

export const emailAddressFiberOpticAlert: ScenarioStep = {
  ...emailAddress,
  group: QuestionGroup.ALERT,
  next: Steps.ADDRESS_LOCATION,
}

export const postalCodeAlert: ScenarioStep = {
  ...postalCodeInternet,
  group: QuestionGroup.ALERT,
  question: 'postal-code_question',
  answerPlaceholder: 'postal-code_answerPlaceholder',
  next: Steps.EMAIL_ADDRESS,
}

export const postalCodeAlertObserver: ScenarioStep = {
  ...postalCodeAlert,
  question: 'postal-code-alert-observer_question',
  tip: 'postal-code-alert-observer_tip',
  next: Steps.HOW_MUCH_PAYMENT,
}

export const confirmAlert: ScenarioStep = {
  id: Steps.CONFIRM_ALERT,
  group: QuestionGroup.ALERT,
  question: 'confirm-alert_question',
  type: QuestionType.CHECKBOX_CONFIRM,
  next: Steps.THANKS,
  answers: [{ id: 'confirm-alert', text: 'common_confirm' }],
  metadata: { grandImage: Images.ALERT_3 },
}

export const confirmFiberOpticAlert: ScenarioStep = {
  ...confirm,
  id: Steps.CONFIRM_ALERT,
  group: QuestionGroup.ALERT,
  question: 'confirm-alert_question',
  answerPlaceholder: 'confirm-alert_answerPlaceholder',
  next: Steps.CONFIRM_FIBER_OPTIC_ALERT,
}

export const confirmFiberOpticAlertB: ScenarioStep = {
  ...confirmAlert,
  group: QuestionGroup.ALERT,
  question: 'confirm-alert_question',
  type: QuestionType.CHECKBOX_CONFIRM,
  next: Steps.THANKS,
  answers: [{ id: 'confirm-alert', text: 'common_confirm' }],
  metadata: { grandImage: Images.ALERT_3 },
}

export const confirmFiberOpticSignup: ScenarioStep = {
  ...confirm,
  id: Steps.CONFIRM_FIBER_OPTIC_ALERT,
  group: QuestionGroup.ALERT,
  question: 'fiber-optic_question',
  answerPlaceholder: 'fiber-optic_answerPlaceholder',
  next: Steps.DONE,
}

export const thanksAlertMobile: ScenarioStep = {
  ...thanks,
  question: 'thanks-alert-mobile_question',
  tip: 'thanks-alert-mobile_tip',
  answers: [
    {
      id: 'continue',
      text: 'common_continue',
    },
  ],
}

export const thanksFiberOpticAlert: ScenarioStep = {
  ...thanks,
  question: 'thanks-fiber-optic-alert_question',
  tip: 'thanks-fiber-optic-alert_tip',
  answers: [
    {
      id: 'continue',
      text: 'common_continue',
    },
  ],
}

export const thanksAlertInternet: ScenarioStep = {
  ...thanks,
  question: 'thanks-alert-internet_question',
  tip: 'thanks-alert-internet_tip',
  answers: [
    {
      id: 'continue',
      text: 'common_continue',
    },
  ],
}

export const thanksAlertCompetition: ScenarioStep = {
  ...thanks,
  question: 'thanks-alert-competition_question',
  tip: 'thanks-alert-competition_tip',
  answers: [
    {
      id: 'continue',
      text: 'common_continue',
    },
  ],
}

export const addressLocationAlert: ScenarioStep = {
  ...addressLocation,
  group: QuestionGroup.ALERT,
  next: Steps.INTERNET_SPEED,
}

export const addressLocationFiberOpticAlert: ScenarioStep = {
  ...addressLocation,
  group: QuestionGroup.ALERT,
  next: Steps.CONFIRM_ALERT,
}

export const selectCurrentProviderInternetAlert: ScenarioStep = {
  ...selectCurrentProvider,
  id: Steps.CURRENT_PROVIDER,
  question: { key: 'select-current-provider_question', options: { providerType: 'Internet' } },
  next: Steps.CURRENT_MONTHLY_PAYMENT,
}

export const currentProviderInternetObserverAlert: ScenarioStep = {
  ...currentProviderInternet,
  // question: { key: 'select-current-provider_question', options: { providerType: 'Internet' } },
  next: Steps.INTERNET_SPEED,
}

export const currentProviderMobileObserverAlert: ScenarioStep = {
  ...currentProviderMobile,
  // question: { key: 'select-current-provider_question', options: { providerType: 'Internet' } },
  next: Steps.HOW_MUCH_DATA,
}

export const currentProviderMobileObserverAlertA: ScenarioStep = {
  ...currentProviderMobile,
  // question: { key: 'select-current-provider_question', options: { providerType: 'Internet' } },
  next: Steps.COVERAGE,
}

export const currentInternetSpeedAlertObserver: ScenarioStep = {
  ...internetSpeedG,
  question: 'current-internet-speed-alert-observer_question',
  answers: [
    { id: '10', text: { key: 'common_mbps-amount', options: { count: 10 } }, next: Steps.POSTAL_CODE_INTERNET },
    { id: '30', text: { key: 'common_mbps-amount', options: { count: 30 } }, next: Steps.POSTAL_CODE_INTERNET },
    { id: '60', text: { key: 'common_mbps-amount', options: { count: 60 } }, next: Steps.POSTAL_CODE_INTERNET },
    { id: '100', text: { key: 'common_mbps-amount', options: { count: 100 } }, next: Steps.POSTAL_CODE_INTERNET },
    { id: '500', text: { key: 'common_mbps-amount', options: { count: 500 } }, next: Steps.POSTAL_CODE_INTERNET },
    { id: '900', text: { key: 'common_mbps-amount', options: { count: 900 } }, next: Steps.POSTAL_CODE_INTERNET },
    { id: 'custom-speed', text: 'common_custom-speed', next: Steps.SLIDER_DATA_AMOUNT },
  ],
}

export const sliderDataInternetAlertObserver: ScenarioStep = {
  ...sliderData,
  next: Steps.POSTAL_CODE_INTERNET,
}

export const callingOptionsAlertObserver: ScenarioStep = {
  ...callingOptions,
  next: Steps.HOW_MUCH_DATA,
}

export const howMuchDataAlertObserver: ScenarioStep = {
  ...howMuchDataC,
  next: Steps.HOW_MUCH_PAYMENT,
  question: 'how-much-data-alert-observer_question',
  answers: [
    { id: '0MB', text: 'option_none' },
    { id: '5000MB', text: { key: 'common_gb-amount', options: { count: 5 } } },
    { id: '10000MB', text: { key: 'common_gb-amount', options: { count: 10 } } },
    { id: '15000MB', text: { key: 'common_gb-amount', options: { count: 15 } } },
    { id: '20000MB', text: { key: 'common_gb-amount', options: { count: 20 } } },
    { id: 'other', text: 'option_other', next: Steps.SLIDER_DATA },
  ],
}

export const sliderDataMobileAlertObserver: ScenarioStep = {
  ...sliderDataMobile,
  next: Steps.HOW_MUCH_PAYMENT,
}
